<template>
  <div class="ship-check">
    <el-tooltip placement="top"
                :visible="visible">
      <template #content>
        <div class="info-table">
          <el-table :data="tableData"
                    style="width: 100%"
                    :header-cell-style="{textAlign: 'center'}">
            <el-table-column v-for="(item,index) in columnData"
                             :key="index"
                             :class-name="item.classname"
                             :min-width="item.width"
                             align="center"
                             :label="item.label">
              <template #default="scope">
                <span>{{scope.row[item.value]?scope.row[item.value]:'--'}}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </template>
      <div id="shipCheck">
      </div>
    </el-tooltip>

  </div>
</template>
<script>
import * as echarts from "echarts";
import moment from "moment";

export default {
  data() {
    return {
      checkData: [],
      xData: [],
      option: {},
      myChart: null,
      colorArray: [
        {
          top: "rgba(71, 68, 217, 1)", //蓝
          bottom: "rgba(71, 68, 217, 0.6)",
        },
        {
          top: "#6cfdb1", //绿
          bottom: "#5e9993",
        },
        {
          top: "#d5865b", //黄
          bottom: "#755951",
        },
      ],
      tableData: [],
      visible: false,
      columnData: [
        {
          value: "date",
          label: "时间",
          width: "20",
        },
        {
          value: "company",
          label: "检查公司",
          width: "20",
        },
        {
          value: "port",
          label: "港口",
          width: "20",
        },
        {
          value: "country",
          label: "国家",
          width: "15",
        },
        {
          value: "defects",
          label: "缺陷数",
          width: "10",
        },
      ],
    };
  },
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    checkInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  computed: {},
  mounted() {
    this.initData();
    document.addEventListener("click", (e) => {
      // console.log(e, e.target.className);
      if (
        this.visible == true &&
        (e.target.className.indexOf("el-table__cell") == -1 ||
          e.target.className.indexOf("cell") == -1 ||
          e.target.className.indexOf("el-table__row") == -1)
      ) {
        // console.log("ccc");
        this.visible = false;
      }
    });
  },
  watch: {
    checkInfo: function (newv) {
      this.initData();
    },
    changeWidth(newV) {
      if (newV) {
        this.initData();
      }
    },
  },
  methods: {
    // 重组数据
    updateCheckData() {
      // console.log(this.checkInfo)
      this.checkData = [];
      let xData = [];
      if (!this.checkInfo) {
        return false;
      }
      let checkTime = {
        label: "检查次数",
        data: [],
        stack: "A",
        color: {
          top: "rgba(109, 200, 236, 1)",
          bottom: "rgba(38, 168, 240, 1)",
        },
      };
      let inspectionNumber = {
        label: "缺陷个数",
        data: [],
        stack: "B",
        color: {
          top: "rgba(91, 143, 249, 1)",
          bottom: "rgba(124, 125, 225,1)",
        },
      };
      let belowKPI = {
        label: "低于kpi",
        data: [],
        labelNum: [],
        stack: "C",
        color: {
          top: "rgba(118, 216, 166, 1)",
          bottom: "rgba(76, 187, 164,1)",
        },
      };
      let exceedKPI = {
        label: "超过kpi",
        data: [],
        stack: "C",
        color: {
          top: "rgba(219, 103, 71, 1)",
          bottom: "rgba(195, 72, 46,1)",
        },
      };
      this.checkInfo.inspection_list.forEach((item) => {
        let type =
          item.inspection_type +
          " kpi=" +
          this.checkInfo.kpi[item.inspection_type];
        xData.push(type);
        // checkTime.data.push([item.inspection_type, item.inspection_count]);
        // inspectionNumber.data.push([item.inspection_type, item.inspection_sum]);
        if (this.checkInfo.records[item.inspection_type]) {
          checkTime.data.push({
            value: item.inspection_count,
            tableData: this.checkInfo.records[item.inspection_type],
          });
        } else {
          checkTime.data.push({
            value: item.inspection_count,
            tableData: [],
          });
        }
        inspectionNumber.data.push(item.inspection_sum);
        let outnumberItem = Number(
          parseFloat(item.inspection_sum / item.inspection_count).toFixed(1)
        );
        if (isNaN(outnumberItem)) {
          outnumberItem = 0;
        }
        // console.log(this.checkInfo.kpi[item.inspection_type], outnumberItem);
        // 比固定kpi多
        if (outnumberItem > this.checkInfo.kpi[item.inspection_type]) {
          exceedKPI.data.push({
            value: outnumberItem,
            outnumber: outnumberItem,
          });
          belowKPI.data.push(0);
        } else {
          belowKPI.data.push(outnumberItem);
          exceedKPI.data.push({
            value: 0,
            outnumber: outnumberItem,
          });
        }
      });
      this.checkData.push(checkTime, inspectionNumber, belowKPI, exceedKPI);
      // console.log(this.checkData, "checkData");
      this.xData = [...new Set(xData)];
    },
    initChart(data, chart) {
      data && chart.setOption(data);
      let that = this;
      data &&
        chart.on("click", function (params) {
          if (params.data.tableData) {
            let data = params.data.tableData;
            data.sort((a, b) => {
              return moment(b.date) - moment(a.date);
            });
            that.tableData = data;
            setTimeout(() => {
              that.visible = true;
            }, 50);
            that.$emit("clearManageInterval");
          }
        });
      // },
    },
    initData() {
      if (this.myChart) {
        this.myChart.dispose();
      }

      var chartDom = document.getElementById("shipCheck");
      this.myChart = echarts.init(chartDom);

      this.updateCheckData();

      if (this.clientWidth <= 1921) {
        this.initDataUnder1920();
      } else if (this.clientWidth > 1921 && this.clientWidth <= 2560) {
        this.initDataUnder2560();
      } else {
        this.initDataUp4368();
      }

      this.initChart(this.option, this.myChart);
    },
    initDataUnder1920() {
      const legendData = [];
      const checkSeries = [];
      this.checkData.forEach((item) => {
        legendData.push(item.label);
        let series = {
          name: item.label,
          data: item.data,
          type: "bar",
          stack: item.stack,
          label: {
            show: true,
            position: "top",
            formatter: (params) => params.value,
            fontSize: "12",
            color: "white", //color of value
          },
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: item.color.top, // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: item.color.bottom, // 100% 处的颜色
                },
              ],
              // global: false, // 缺省为 false
            },
          },
        };
        if (item.label == "超过kpi") {
          series.label = {
            show: true,
            position: "top",
            formatter: (params) => {
              return params.data.outnumber;
            },
            fontSize: "12",
            color: "white", //color of value
          };
          // series.itemStyle.borderColor = "#df6043";
          // series.itemStyle.borderWidth = 2;
          // series.itemStyle.borderType = "dashed";
        }
        if (item.label == "低于kpi") {
          series.label = {
            show: false,
          };
        }
        checkSeries.push(series);
      });
      this.option = {
        grid: {
          icon: "circle",
          left: "30",
          right: "0",
          top: "40",
          bottom: "30",
          containLabel: false,
        },
        tooltip: {
          show: false,
          trigger: "item",
          className: "goods-tooltip",
          textStyle: {
            color: "#fff", // 文字颜色
            fontSize: 10,
          },
          backgroundColor: "#061f3cd9",
        },
        legend: {
          itemWidth: 18,
          padding: [2, 3],
          itemGap: 5,
          data: legendData,
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.xData,
            axisLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisLabel: {
              color: "rgba(255, 255, 255, 1)",
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 30,
            scale: true,
            splitNumber: 3,
            axisLine: {
              // show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisTick: {
              // show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisLabel: {
              color: "rgba(255, 255, 255, 0.7)",
              // formatter: '{value}'
            },
          },
        ],
        series: checkSeries,
      };
    },
    initDataUnder2560() {
      const legendData = [];
      const checkSeries = [];
      this.checkData.forEach((item) => {
        legendData.push(item.label);

        let series = {
          name: item.label,
          data: item.data,
          type: "bar",
          stack: item.stack,
          label: {
            show: true,
            position: "top",
            formatter: (params) => params.value,
            fontSize: "24",
            color: "white", //color of value
          },
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: item.color.top, // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: item.color.bottom, // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
        };
        if (item.label == "超过kpi") {
          series.label = {
            show: true,
            position: "top",
            formatter: (params) => {
              return params.data.outnumber;
            },
            fontSize: "24",
            color: "white", //color of value
          };
        }
        if (item.label == "低于kpi") {
          series.label = {
            show: false,
          };
        }
        checkSeries.push(series);
      });
      this.option = {
        grid: {
          left: "60",
          right: "0",
          top: "70",
          bottom: "60",
          containLabel: false,
        },
        tooltip: {
          show: false,
          trigger: "axis",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 24,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        legend: {
          data: legendData,
          textStyle: {
            fontSize: 24,
            color: "rgba(255, 255, 255, 1)",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.xData,
            axisLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisLabel: {
              fontSize: 24,
              color: "rgba(255, 255, 255, 1)",
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 30,
            scale: true,
            splitNumber: 3,
            axisLine: {
              // show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisTick: {
              // show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisLabel: {
              fontSize: 20,
              color: "rgba(255, 255, 255, 0.7)",
              // formatter: '{value}'
            },
          },
        ],
        series: checkSeries,
      };
    },
    initDataUp4368() {
      const legendData = [];
      const checkSeries = [];
      this.checkData.forEach((item) => {
        legendData.push(item.label);

        let series = {
          name: item.label,
          data: item.data,
          type: "bar",
          stack: item.stack,
          label: {
            show: true,
            position: "top",
            formatter: (params) => params.value,
            fontSize: "30",
            color: "white", //color of value
          },
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: item.color.top, // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: item.color.bottom, // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
        };
        if (item.label == "超过kpi") {
          series.label = {
            show: true,
            position: "top",
            formatter: (params) => {
              return params.data.outnumber;
            },
            fontSize: "30",
            color: "white", //color of value
          };
        }
        if (item.label == "低于kpi") {
          series.label = {
            show: false,
          };
        }
        checkSeries.push(series);
      });
      this.option = {
        grid: {
          left: "60",
          right: "0",
          top: "80",
          bottom: "80",
          containLabel: false,
        },
        tooltip: {
          show: false,
          trigger: "axis",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 30,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        legend: {
          data: legendData,
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            fontSize: 30,
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.xData,
            axisLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisLabel: {
              color: "rgba(255, 255, 255, 1)",
              fontSize: 30,
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 30,
            scale: true,
            splitNumber: 3,
            axisLine: {
              // show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
              },
            },
            axisTick: {
              // show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.2)",
                width: 2,
              },
            },
            axisLabel: {
              color: "rgba(255, 255, 255, 0.7)",
              fontSize: 32,
              formatter: "{value}",
            },
          },
        ],
        series: checkSeries,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.ship-check {
  width: 100%;
  height: 100%;
}
#shipCheck {
  width: 100%;
  height: 100%;
}
.info-table {
  max-width: 50vw !important;
  min-width: 30vw;
  max-height: 50vh !important;
  word-wrap: break-word;
  overflow: auto;
  // background-color: #011832d9 !important;
  border: 0px !important;
  span {
    max-width: 50vw !important;
    word-wrap: break-word;
  }
}
::v-deep .el-popper {
  overflow: hidden !important;
}
:deep(.el-table) {
  background-color: transparent !important;
  --el-table-border-color: #0118327a !important;
  --el-table-row-hover-bg-color: #0118327a !important;
  cursor: pointer;
}

:deep(.el-table tr) {
  background: transparent !important;
  color: white;
}
:deep(.el-table th.el-table__cell) {
  background: transparent !important;
  color: #53c6ef;
}
:deep(.el-table tr:hover) {
  background: transparent !important;
  color: white;
}
:deep(.el-table .cell) {
  padding: 0 1% !important;
  word-break: break-word !important;
}
</style>
